import { Gamepad2 } from "lucide-react";
import { DEFAULT_DEVICES, DEVICE_LABEL } from "../../lib/console";

export const ConsoleDevices = ({ connected, devices, learning, onLearn }) => (
  <section data-testid="console-devices" className="grid gap-4 border border-slate-800 bg-slate-950/70 p-5">
    <div>
      <p className="lab-label !text-cyan-300">Console check · button boxes</p>
      <p className="mt-1 text-xs text-slate-500">
        The boxes appear as game controllers. Chrome only lists a box after you press something on it - press any button on each, then check it shows below.
        If a box is matched to the wrong role, click Learn and press a button on the right one.
      </p>
    </div>
    <div className="grid gap-3 sm:grid-cols-2">
      {["controller", "macro"].map((role) => {
        const c = connected[role];
        const learningThis = learning?.type === "device" && learning.role === role;
        return (
          <div key={role} data-testid={`console-device-${role}`} data-state={c ? "online" : "offline"} className={`border p-4 ${c ? "border-emerald-400/40 bg-emerald-400/5" : "border-slate-800"}`}>
            <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-300"><Gamepad2 size={14} className={c ? "text-emerald-300" : "text-slate-600"} /> {DEVICE_LABEL[role]}</p>
            <p className="mt-2 font-mono text-xs text-slate-400 break-all">{c ? `${c.id} · ${c.buttons} buttons · ${c.axes} axes` : "not detected - press a button on it"}</p>
            <p className="mt-1 font-mono text-[11px] text-slate-600">{devices[role] ? `matches ids containing "${devices[role]}"` : DEFAULT_DEVICES[role] ? `matches ids containing "${DEFAULT_DEVICES[role]}" (default)` : "any other connected box"}</p>
            <button type="button" data-testid={`console-learn-${role}`} onClick={() => onLearn(role)} className={`lab-btn-ghost mt-3 py-1 text-xs ${learningThis ? "animate-pulse border-amber-300 text-amber-200" : ""}`}>
              {learningThis ? "Press any button on this box…" : "Learn this box"}
            </button>
          </div>
        );
      })}
    </div>
  </section>
);
